import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RoleFilterSelected } from 'src/app/shared/role-filter-dropdown-row/role-filter-dropdown-row.component';
import { RoleFilterIds, RoleFilterService } from 'src/app/services/role-filter.service';
import { ServicesPageResponse } from '../../home/interfaces/HomeData.interface';

export interface IncidenceReasonDTO {
  Id: string,
  Code: string,
  Category?: number
}
export interface IncidenceReason {
  id: string,
  code: string,
  category?: number
}
@Injectable({
  providedIn: 'root',
})
export class MyServicesService {
  constructor(
    private http: HttpClient,
    private RoleFilterService: RoleFilterService
  ) { }

  baseUrl = environment.tracking_url;
  productUrl = environment.products_url;

  todayServices(page: number, searchValue: string, RoleFilter: RoleFilterSelected): Observable<ServicesPageResponse> {
    const RoleFilterIds: RoleFilterIds = this.RoleFilterService.convertRoleFilterSelected_To_RoleFilterIds(RoleFilter)
    let url = `${this.baseUrl}/fleet-manager/services/today?page=${page}`;
    if (searchValue) {
      url += `&search=${searchValue}`;
    }

    return this.http.post<ServicesPageResponse>(url, RoleFilterIds);

  }
  nextServices(page: number, searchValue: string, RoleFilter: RoleFilterSelected): Observable<ServicesPageResponse> {
    const RoleFilterIds: RoleFilterIds = this.RoleFilterService.convertRoleFilterSelected_To_RoleFilterIds(RoleFilter)
    let url = `${this.baseUrl}/fleet-manager/services/future?page=${page}`;
    if (searchValue) {
      url += `&search=${searchValue}`;
    }

    return this.http.post<ServicesPageResponse>(url, RoleFilterIds);

  }
  historyServices(page: number, searchValue: string, RoleFilter: RoleFilterSelected, statuses?: number[], dateFrom?: string, dateTo?: string) {
    const RoleFilterIds: RoleFilterIds = this.RoleFilterService.convertRoleFilterSelected_To_RoleFilterIds(RoleFilter)
    let url = `${this.baseUrl}/fleet-manager/services/past?page=${page}`;
    if (searchValue) {
      url += `&search=${searchValue}`;
    }

    const payload = {
      ...RoleFilterIds,
      Statuses: statuses && statuses.length > 0 ? statuses : undefined,
      DateFrom: dateFrom,
      DateTo: dateTo
    };

    return this.http.post<ServicesPageResponse>(url, payload);

  }
  downloadSingleCsv(serviceId: string): Observable<Blob> {
    const url = `${this.baseUrl}/tracking/order/download/details?caflerHash=${serviceId}&lang=es-ES`;
    return this.http.get(url, {
      responseType: 'blob',
    });
  }

  cancelService(serviceId: string) {
    const url = `${this.baseUrl}/fleet-manager/order?caflerHash=${serviceId}`;
    return this.http.patch(url, {});
  }
  getFailureReasons() {
    const url = `${this.productUrl}/api/failure-reasons`;
    return this.http.get<IncidenceReasonDTO[]>(url).pipe(
      map((items) => this.mapToOptions(items)),
      shareReplay(1),
      catchError((error) => {
        console.error('Error loading failure reasons', error);
        return throwError(() => error);
      }));
  }
  getCancelReasons() {
    const url = `${this.productUrl}/api/cancellation-reasons`;
    return this.http.get<IncidenceReasonDTO[]>(url).pipe(
      map((items) => this.mapToOptions(items)),
      shareReplay(1),
      catchError((error) => {
        console.error('Error loading failure reasons', error);
        return throwError(() => error);
      }));

  }
  private mapToOptions(
    dtos: IncidenceReasonDTO[]
  ): IncidenceReason[] {
    if (!Array.isArray(dtos) || dtos.length === 0) {
      return [];
    }
    return dtos
      .filter((dto) => dto?.Code)
      .map((dto) => ({
        category: dto.Category,
        code: dto.Code,
        id: dto.Id,
      }));
  }
  getReasonsFromApi(): Observable<IncidenceReason[]> {
    return forkJoin({
      failureReasons: this.getFailureReasons().pipe(
        catchError(error => {
          console.error('[getFailureReasons] Error al obtener razones de fallo', error);
          return of([]);
        })
      ),
      cancelReasons: this.getCancelReasons().pipe(
        catchError(error => {
          console.error('[getCancelReasons] Error al obtener razones de cancelación', error);
          return of([]);
        })
      )
    }).pipe(
      map(({ failureReasons, cancelReasons }) => [
        ...failureReasons,
        ...cancelReasons
      ])
    );
  }

}
